import { ref } from "vue";
import { useRoute, useRouter } from "vue-router";
import { useStore } from "vuex";
import { removeItem } from "@/utils/storage.js";

// Payment providers redirect back with different keys: most send `tx_ref` and
// `status=successful`, BlockRadar sends `reference` and `status=success|pending|failed`.
// vue-router hands a key repeated in the URL over as an array.
const SUCCESS_STATUSES = ["successful", "success"];
const PENDING_STATUSES = ["pending"];
const FAILED_STATUSES = ["cancelled", "failed"];

export function readFundingRedirect(query) {
  const statuses = [].concat(query.status ?? []);
  const matches = (list) => statuses.some((status) => list.includes(status));
  let status = null;
  if (matches(SUCCESS_STATUSES)) status = "successful";
  else if (matches(PENDING_STATUSES)) status = "pending";
  else if (matches(FAILED_STATUSES)) status = "failed";
  return { reference: query.tx_ref || query.reference, status };
}

export function useFundNotification() {
  const store = useStore();
  const route = useRoute();
  const router = useRouter();
  const isSuccessful = ref(false);
  // TODO
  // abstract all funding methods confirmation logic to this file norigen, plaid, stitch etc
  const checkFundingStatus = async () => {
    removeItem("fundPayload");
    const { reference, status } = readFundingRedirect(route.query);
    if (reference) {
      if (status === "successful") {
        router.push({ name: route.name });
        store.dispatch("showToast", {
          description: "Wallet funding successful.",
          display: true,
          type: "success",
        });
        await Promise.all([
          store.dispatch("investorModule/getWalletBalance"),
          store.dispatch("investorModule/getEntityCard"),
        ]);
        isSuccessful.value = true;
      } else if (status === "pending") {
        router.push({ name: route.name });
        store.dispatch("showToast", {
          description: "Your payment is being confirmed. Your wallet will be credited once it settles.",
          display: true,
          type: "info",
        });
      } else if (status === "failed") {
        router.push({ name: route.name });
        store.dispatch("showToast", {
          description: "Wallet funding failed.",
          display: true,
          type: "error",
        });
      }
      // setTimeout(() => {
      //     window.location = window.location.origin + window.location.pathname;
      // }, 3000);
    }
  };

  return { checkFundingStatus, isSuccessful };
}
